import { Ga4Service } from '@data-terminal/base/app';

export function initGA4Service(service: Ga4Service): () => void {
    return () => {
        service.listenToEvents();
    };
}
